module.exports = Object.freeze({
  IMAGE_ID: "image_id",
  DATE_TAKEN_MILLISECONDS: "date_taken_milliseconds",
  DATE_POSTED_MILLISECONDS: "date_posted_milliseconds",
  DATE_MODIFIED_MILLISECONDS: "date_modified_milliseconds",
  USER_TIMEZONE: "user_timezone",
  ASSESSMENT: "assessment",
});
